<div class="d-flex align-items-center pb-8">
    <ng-content></ng-content>
</div>
